import { DEFAULT_BLOCK_COLOR } from "~/constants/style";
import {
  DartboardKind,
  DashboardKind,
  FolderKind,
  IconKind,
  PageKind,
  PagePseudoKind,
  SpaceKind,
  ViewKind,
} from "~/shared/enums";
import type { Agents, DashboardsRoot, Home, Inbox, NotFound, SpecificPageKind, ViewsRoot } from "~/shared/types";

export const PAGES_PARTIALLY_EDITABLE = new Set<SpecificPageKind>([
  DartboardKind.FINISHED,
  DartboardKind.CUSTOM,
  FolderKind.DEFAULT,
  FolderKind.OTHER,
  SpaceKind.WORKSPACE,
  SpaceKind.OTHER,
  SpaceKind.PERSONAL,
  ViewKind.CUSTOM,
  DashboardKind.DASHBOARD,
]);

export const EXCLUDED_VIEW_KINDS = new Set([ViewKind.SEARCH, ViewKind.TRASH, ViewKind.MY_TASKS]);

export const FILTERS_PSEUDO_SECTION_KEY = "@filters";
export const FAVORITES_PSEUDO_SECTION_KEY = "@favorites";
export const LEFTBAR_PSEUDO_SECTION_KEY = "@leftbar";
export const SPACES_PSEUDO_SECTION_KEY = "@spaces";
export const ARCHIVE_PSEUDO_SECTION_KEY_SUFFIX = "/@archive";
export const FOOTER_PSEUDO_SECTION_KEY = "@footer";
export const AI_CHAT_PSEUDO_SECTION_KEY = "@ai-chat";
export const AGENTS_LEFTBAR_PSEUDO_SECTION_KEY_SUFFIX = "/@agents/@leftbar";
export const BUILD_LEFTBAR_PSEUDO_SECTION_KEY_SUFFIX = "/@build/@leftbar";
export const PINNED_CHATS_PSEUDO_SECTION_KEY = "@pinned-chats";
export const CHATS_PSEUDO_SECTION_KEY = "@chats";

export const NOT_FOUND_PSEUDO_PAGE_DUID = "@not-found";
export const NOT_FOUND_PSEUDO_PAGE: NotFound = {
  duid: NOT_FOUND_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.NOT_FOUND,
  pageKind: PageKind.NOT_FOUND,
  order: "",
  title: "Not found",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "notfound",
  colorHex: DEFAULT_BLOCK_COLOR,
};

export const HOME_PSEUDO_PAGE_DUID = "@home";
export const HOME_PSEUDO_PAGE: Home = {
  duid: HOME_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.HOME,
  pageKind: PageKind.HOME,
  order: "",
  title: "Home",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "home",
  colorHex: DEFAULT_BLOCK_COLOR,
};

export const AGENTS_PSEUDO_PAGE_DUID = "@agents";
export const AGENTS_PSEUDO_PAGE: Agents = {
  duid: AGENTS_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.AGENTS,
  pageKind: PageKind.AGENTS,
  order: "",
  title: "Agents",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "agent",
  colorHex: DEFAULT_BLOCK_COLOR,
};

export const INBOX_PSEUDO_PAGE_DUID = "@inbox";
export const INBOX_PSEUDO_PAGE: Inbox = {
  duid: INBOX_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.INBOX,
  pageKind: PageKind.INBOX,
  order: "",
  title: "Inbox",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "inbox",
  colorHex: DEFAULT_BLOCK_COLOR,
};

export const DASHBOARDS_PSEUDO_PAGE_DUID = "@dashboards";
export const DASHBOARDS_PSEUDO_PAGE: DashboardsRoot = {
  duid: DASHBOARDS_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.DASHBOARDS,
  pageKind: PageKind.DASHBOARDS_ROOT,
  order: "",
  title: "Dashboards",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "dashboard",
  colorHex: DEFAULT_BLOCK_COLOR,
};

export const VIEWS_PSEUDO_PAGE_DUID = "@views";
export const VIEWS_PSEUDO_PAGE: ViewsRoot = {
  duid: VIEWS_PSEUDO_PAGE_DUID,
  kind: PagePseudoKind.VIEWS,
  pageKind: PageKind.VIEWS_ROOT,
  order: "",
  title: "Views",
  description: "",
  iconKind: IconKind.ICON,
  iconNameOrEmoji: "view",
  colorHex: DEFAULT_BLOCK_COLOR,
};
